export default __webpack_public_path__ + "static/media/documents-title-icon.afd04216.svg";